export const formatDateFromISO = (dateString: string): string => {
  const date = new Date(dateString);

  if (!date.getTime()) {
    return '';
  }

  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const formatToISODate = (date: Date = new Date()): string => date.toISOString().split('.')[0];

export const getCurrentDateString = (date: Date = new Date()): string => date.toISOString().split('T')[0];
